import React, { useContext, useEffect, useState } from 'react';
import { Context } from './global-data-provider';
import api from '../api/api';

export const PostsListContext = React.createContext({});

function PostsListProvider(props) {
  const { deletedPostManager } = useContext(Context);
  const p = {};

  [p.postLoaded, p.setPostLoaded] = useState(false);
  [p.hasMore, p.setHasMore] = useState(false);
  [p.posts, p.setPosts] = useState([]);
  [p.pageNumber, p.setPageNumber] = useState(0);

  p.loadPosts = (cat, pn, s) => {
    if (pn === 0 || p.hasMore) {
      api.getPosts(cat, pn, s === undefined ? deletedPostManager.getListCount() : s).then((response) => {
        if (response.posts) {
          p.setPosts(p.createPostsList(response.posts));
          if (!p.postLoaded) {
            p.setPostLoaded(true);
          }

          p.setHasMore(response.has_more);
        } else {
          p.setHasMore(false);
        }

        p.setPageNumber(pn);
      });
    }
  };

  p.createPostsList = (list) => {
    let postList = [];
    for (let i = 0; i < list.length / 3; i++) {
      postList[i] = [];
      for (let j = 0; j < 3; j++) {
        const index = i * 3 + j;
        if (list[index] !== undefined) {
          postList[i][j] = list[index];
        } else {
          break;
        }
      }
    }

    return p.posts.concat(postList);
  };

  p.isRendered = (id) => {
    for (let i = 0; i < p.posts.length; i++) {
      for (let j = 0; j < p.posts[i].length; j++) {
        if (p.posts[i][j].id === id) {
          return true;
        }
      }
    }

    return false;
  };

  useEffect(() => {
    p.loadPosts('all', 0, 0);
  }, []);

  return <PostsListContext.Provider value={[p]}>{props.children}</PostsListContext.Provider>;
}

export default PostsListProvider;
